import React from 'react';
import PropTypes from 'prop-types';

import Translation from './Translation';

function Page({
	children,
	content: {title, pubdate, edvnumber, contactAddress},
	number,
	maxPageNumber,
}) {
	return (
		<div className="slx-mounting-page">
			<img
				className="slx-mounting-page__logo"
				src="/assets/images/logo-black.svg" />
			<div className="slx-mounting-page__content">
				{children}
			</div>
			<footer className="slx-mounting-page__footer">
				<h1 className="slx-mounting-page__footer-title">{title}</h1>
				{edvnumber && <span> | # {edvnumber}</span>}
				{pubdate && <span> | {pubdate}</span>}
				{' | '}
				<Translation name="selux-ag-reserve-technical-and-graphical-changes" />
				<br />
				<div
					className="slx-mounting-page__footer-inprint"
					dangerouslySetInnerHTML={{__html: contactAddress}}
					/>
				<span className="slx-mounting-page__footer-number">{number}/{maxPageNumber}</span>
			</footer>
		</div>
	);
}

Page.propTypes = {
	children: PropTypes.node,
	content: PropTypes.object.isRequired,
	number: PropTypes.number.isRequired,
	maxPageNumber: PropTypes.number.isRequired,
};

export default React.memo(Page);
